import { ReportSdk } from 'lib-klab-sdks';
import {
    TimeSheetSummaryItem,
    TimeSheetSummaryPage,
    TimeSheetSummaryResponse,
    TimeSheetSummaryResponseMetadata,
} from '../../../domain/models/reports/time-sheet-summary.model';
import { DateRange } from '../../../domain/models/reports/request/time-sheet-summary.request';

export function mapSdkDateRangeToDomain(dr?: ReportSdk.DateRange): DateRange | undefined {
    if (!dr) return undefined;
    return {
        startDate: dr.startDate,
        endDate: dr.endDate,
    };
}

export function mapSdkTimeSheetMetadataToDomain(
    metadata?: ReportSdk.TimeSheetSummaryResponseMetadata,
): TimeSheetSummaryResponseMetadata {
    return {
        employeeId: metadata?.employeeId,
        dateRange: mapSdkDateRangeToDomain(metadata?.dateRange),
    };
}

export function mapSdkPaginationToDomain(page?: ReportSdk.PaginationResponse): TimeSheetSummaryPage {
    return {
        page: page?.page ?? 0,
        size: page?.size ?? 0,
        totalElements: page?.totalElements ?? 0,
        totalPages: page?.totalPages ?? 0,
    };
}

export function mapSdkTimeSheetItemToDomain(item: ReportSdk.TimeSheetSummaryItem): TimeSheetSummaryItem {
    return {
        date: item.date,
        startAt: item.startAt,
        endedAt: item.endedAt,
        totalSeconds: item.totalSeconds,
        officeSeconds: item.officeSeconds,
        activeSeconds: item.activeSeconds,
        productiveSeconds: item.productiveSeconds,
        unproductiveSeconds: item.unproductiveSeconds,
        neutralSeconds: item.neutralSeconds,
        idleSeconds: item.idleSeconds,
        offlineSeconds: item.offlineSeconds,
        productivityPercentage: item.productivityPercentage,
        esFeriado: item.holiday === true,
        // El motivo se propaga tal cual: es lo que deja a la vista decir
        // "No laborable" en lugar de un guion que significa tres cosas.
        noExpectedReason: item.noExpectedReason ?? null,
    };
}

export function mapSdkTimeSheetSummaryResponseToDomain(
    resp: ReportSdk.TimeSheetSummaryResponse,
): TimeSheetSummaryResponse {
    return {
        metadata: mapSdkTimeSheetMetadataToDomain(resp?.metadata),
        content: (resp?.content ?? []).map(mapSdkTimeSheetItemToDomain),
        page: mapSdkPaginationToDomain(resp?.page),
    };
}
